import {userStore} from 'app/store/global';

export const isAdmin = (): boolean => userStore.user.is_admin;
